// extracted by mini-css-extract-plugin
export default {"Search":"Search_Search__x4Xto","icon":"Search_icon__likDg"};